import type { AxiosInstance } from "axios"
import handleQueryResult from "./util/handleQueryResult"

type EmailTemplate = {
	subject: string
	body: string
}

type SmsTemplate = {
	patientConditionId: number
	phoneNumber: string
	body: string
}

export type TemplateKey = {
	name: string
	isOverriddenForTenant: boolean
	templateKey: string
}

export class TemplateQueryClient {
	constructor(private axiosClient: AxiosInstance) {}

	private base = "/api/admin/templates"

	public getEmailTemplateKeys = () =>
		handleQueryResult(
			this.axiosClient.get<TemplateKey[]>(
				`${this.base}/emails/templateKeys`
			)
		)

	public getSmsTemplateKeys = () =>
		handleQueryResult(
			this.axiosClient.get<TemplateKey[]>(`${this.base}/sms/templateKeys`)
		)

	public getEmailPreview = (templateKey: string) => {
		const params = new URLSearchParams()
		params.append("templateKey", templateKey.toString())
		return handleQueryResult(
			this.axiosClient.get<EmailTemplate>(
				`${this.base}/emails/preview?${params.toString()}`
			)
		)
	}

	public getSmsPreview = (templateKey: string) => {
		const params = new URLSearchParams()
		params.append("templateKey", templateKey.toString())
		return handleQueryResult(
			this.axiosClient.get<SmsTemplate>(
				`${this.base}/sms/preview?${params.toString()}`
			)
		)
	}

	public sendSms = (request: { templateKey: string; phoneNumber: string }) =>
		this.axiosClient.post<void>(`${this.base}/sms/send`, request)
}
